// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_n-1";
export var movingGradient = "_n-4";
export var movingGradientBlock = "_n-2";
export var skeleton = "_n-0";
export var skeletonText = "_n-3";